import { Link, Typography } from "@mui/material";
import { Links } from "src/constants";
import { FeedItemDto, FeedItemTeamValueDto } from "src/http";

interface Props {
  feedItem: FeedItemDto;
}

const RoleTeamPropertyChange = (props: Props) => {
  const value = props.feedItem.propertyChange!.value as FeedItemTeamValueDto;

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> updated the role's team to </span>
      <strong>
        <Link href={Links.Team(value.slug)}>{value.name}</Link>
      </strong>
    </Typography>
  );
};

export { RoleTeamPropertyChange };
